import React from 'react';

import { cn } from '@lyearn/style';
import { BaseMenuItem, Checkbox, Stack, Typography } from '@lyearn/ui';

import { FilterGroupLabelProps } from './types';

function FilterGroupLabel(props: FilterGroupLabelProps) {
  const {
    label,
    isGroupSelectionEnabled,
    onClick,
    isSelected,
    indeterminate,
    isSingleSelect,
    className,
  } = props;

  const DefaultLabel = (
    <Typography
      as="p"
      className="mx-12 mt-8 mb-0"
      color="text-text-placeholder"
      variant="label-caps">
      {label}
    </Typography>
  );

  if (!label) {
    return null;
  }

  if (isSingleSelect) {
    return DefaultLabel;
  }

  if (isGroupSelectionEnabled) {
    return (
      <BaseMenuItem
        className={cn(
          'group my-2 flex w-full items-center justify-between rounded-8 bg-bg-primary py-8 ps-0 pe-12 space-s-12',
          className,
        )}
        onClick={onClick}>
        <Stack alignItems="center" className="w-[86%]">
          <Typography className="truncate ms-10" color="text-text-primary" variant="label-02">
            {label}
          </Typography>
        </Stack>
        <Checkbox
          parent
          checked={isSelected}
          className="rounded-4 bg-bg-primary"
          indeterminate={indeterminate}
        />
      </BaseMenuItem>
    );
  }

  return DefaultLabel;
}

export default React.memo(FilterGroupLabel);
